<template>
  <div>
    <FITFormCard>
      <div slot="header">
        <b-row>
          <b-col>
            <h4>{{$t('adm.team.header')}} {{$t('adm.team.list')}}</h4>
          </b-col>
          <b-col cols="6" class="text-right">
            <b-button variant="primary" size="md" @click="createTeam"><i class="fa fa-plus-circle mr-2"></i>{{ $t('adm.team.createTeam') }}</b-button>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable @onRowSelected="onRowSelected" vuexModule="Adm" searchAction="getTeamList" :columns="columns"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue';
import { FITSearchableTable, FITFormCard } from '@/components'
export default {
  name: 'TeamList',
  methods: {
    onRowSelected(evt) {
      this.$router.push({ name: 'Create Team', params: { detail: evt } });
    },
    createTeam() {
      this.$router.push('/adm/team/create');
    },
    convertEnglishName(type, item) {
      var englishName = Vue.options.filters.isEmpty(item[type + 'EnglishFirstname']);
      if (englishName !== 'N/A') {
        englishName = englishName + ' ' + item[type + 'EnglishLastname'];
      }
      return englishName;
    },
    convertChineseName(type, item) {
      var chineseName = Vue.options.filters.isEmpty(item[type + 'ChineseFirstname']);
      if (chineseName !== 'N/A') {
        chineseName = item[type + 'ChineseLastname'] + chineseName;
      }
      return chineseName;
    }
  },
  data() {
    return {
      columns: [{
        key: 'teamCode',
        label: this.$t('adm.team.teamCode')
      }, {
        key: 'agentCode',
        label: this.$t('adm.team.leaderCode'),
        formatter: (row, key, item) => {
          return Vue.options.filters.isEmpty(row);
        }
      }, {
        key: 'leader',
        label: this.$t('adm.team.leader'),
        formatter: (row, key, item) => {
          var eng = Vue.options.filters.isEmpty(item.leaderEnglishName);
          var chi = Vue.options.filters.isEmpty(item.leaderChineseName);
          if (eng !== 'N/A' && chi !== 'N/A') {
            return eng + '</br>' + chi
          }
          if (eng == 'N/A') {
            return chi;
          }
          return eng;
        }
      }, {
        key: 'numberOfMember',
        label: this.$t('adm.team.numberOfMember')
      }],
      actions: [
        { text: this.$t('osm.contents.general.detail'), key: 'detail' },
        { text: this.$t('osm.contents.general.outstandingRequirement.title'), key: 'outstanding' }
      ],
    }
  },
  components: {
    FITSearchableTable,
    FITFormCard
  },
}

</script>



// WEBPACK FOOTER //
// src/Adm/Team/TeamList.vue